import { render } from "./OysterApp.vue?vue&type=template&id=8afa2480"
import script from "./OysterApp.vue?vue&type=script&lang=js"
export * from "./OysterApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__